export const FREE_CHALLENGE_PRICING = 'FREE_CHALLENGE_PRICING';
export const ONLY_ONE_TIME_PAYMENT_PRICING = 'ONLY_ONE_TIME_PAYMENT_PRICING';
export const ONLY_PAID_PLANS_DATA_HOOK = 'ONLY_PAID_PLAN_DATA_HOOK';
export const ONLY_HIDDEN_PAID_PLANS_DATA_HOOK = 'SINGLE_PAYMENT_DATA_HOOK';
export const PAID_PLAN_DATA_HOOK = 'PAID_PLAN_DATA_HOOK';
export const SINGLE_PAYMENT_DATA_HOOK = 'SINGLE_PAYMENT_DATA_HOOK';
export const INCLUDED_IN_YOUR_PLAN_DATA_HOOK =
  'INCLUDED_IN_YOUR_PLAN_DATA_HOOK';
